<template>
    <el-form :model="value" ref="formRef" :rules="rules" label-position="top">
        <Panel title="连接池配置">
            <el-row>
                <el-col :span='12'>
                    <el-form-item class="flex-1" label="服务器IP地址" prop='host'>
                        <el-input v-model="value.host"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span='12'>
                    <el-form-item class="flex-1" label="端口号" prop='port'>
                        <el-input v-model="value.port"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span='12'>
                    <el-form-item class="flex-1" label="用户名" prop='username'>
                        <el-input v-model="value.username"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span='12'>
                    <el-form-item class="flex-1" label="密码" prop='password'>
                        <el-input v-model="value.password"></el-input>
                    </el-form-item>
                </el-col>
            </el-row>
        </Panel>
        <Panel title="高级配置" collapse>
            <el-row>
                <el-col :span='12'>
                    <el-form-item class="flex-1" label="是否使用SSL" prop='ssl'>
                        <el-radio v-model="value.ssl" label="true">是</el-radio>
                        <el-radio v-model="value.ssl" label="false">否</el-radio>
                    </el-form-item>
                </el-col>
            </el-row>
        </Panel>
    </el-form>
</template>
<script>
export default {
    // host: "",
    // port: "",
    // username: "",
    // password: "",
    // vhost: "",
    // ssl: "false"
    props: {
        value: {type: Object, default: () => ({})},
        // init: Boolean,
        init: { type: String, default: '' },
    },
    data() {
        return {
            rules: {
                host: [{required: true, trigger: "blur", message: "这是必填字段"}],
                port: [{required: true, trigger: "blur", message: "这是必填字段"}],
                vhost: [{required: true, trigger: "blur", message: "这是必填字段"}]
            }
        };
    },
    mounted() {
        // if (!this.init) {
        //     this.$set(this.value, 'ssl', "false");
        // }
         if (!this.value.ssl) {
            this.$set(this.value, 'ssl', "false");
        }
    },
    methods: {
        validate() {
            return this.$refs.formRef.validate();
        }
    }
};
</script>

